import { render } from "./ScoringCard.vue?vue&type=template&id=78b27b70"
import script from "./ScoringCard.vue?vue&type=script&lang=js"
export * from "./ScoringCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__